/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { answerRedirectBridge } from '@groundworks/ngx-groundworks-auth';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (!answerRedirectBridge()) {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
}
